import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiError } from '../schemas/common.schema';

const c = initContract();

export const AccountConfigLandingSchema = z.object({
  accepts_applications: z.boolean().optional(),
  form_contact_phone_enabled: z.boolean().optional(),
  form_contact_email_enabled: z.boolean().optional(),
  form_regions_field_enabled: z.boolean().optional(),
});

export const AccountResponseSchema = z.object({
  _id: z.string(),
  account_name: z.string().optional(),
  account_logo: z.string().optional(),
  account_site: z.string().optional(),
  account_access: z.array(z.any()).optional(),
  account_courses: z.array(z.string()).optional(),
  account_locale: z.string().optional(),
  account_has_teams: z.boolean().optional(),
  account_locales_ui: z.array(z.string()).optional(),
  account_token: z.string().optional(),
  account_extra_props: z.any().optional(),
  account_country_iso: z.string().optional(),
  account_config_landing: AccountConfigLandingSchema.optional(),
});

export const accountsContract = c.router({
  detectByCountry: {
    method: 'GET',
    path: '/accounts/detect-by-country/:country_iso',
    pathParams: z.object({ country_iso: z.string() }),
    responses: {
      200: z.object({
        data: z.array(AccountResponseSchema),
        success: z.boolean(),
        fallback_used: z.boolean().optional(),
        requested_country: z.string().optional(),
      }),
    },
  },
  getAccountById: {
    method: 'GET',
    path: '/accounts/:id',
    pathParams: z.object({ id: z.string() }),
    responses: {
      200: z.object({ data: AccountResponseSchema, success: z.boolean() }),
      400: apiError,
      404: apiError,
    },
  },
});

export type AccountResponseDto = z.infer<typeof AccountResponseSchema>;
